import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { WebsiteContentProvider } from './WebsiteContentContext';

export const MarketingLayout = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <WebsiteContentProvider>
      <div data-testid="marketing-layout" className="min-h-screen flex flex-col bg-white text-left">
        <Header transparentOnTop={isHome} />
        <main className={isHome ? '' : 'pt-20'}>
          <Outlet />
        </main>
        <Footer />
      </div>
    </WebsiteContentProvider>
  );
};

export default MarketingLayout;
